var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketInstructionOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 120,
    viewBox: "0 0 144 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3248_5001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140 120H4V119H3V118H2V117H1V116H0V52H1V51H2V50H3V49H4V48H140V49H141V50H142V51H143V52H144V116H143V117H142V118H141V119H140V120Z",
    fill: "#26261E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5 48.5V49.5H140.5V50.5H141.5V51.5H142.5V52.5H143.5V115.5H142.5V116.5H141.5V117.5H140.5V118.5H139.5V119.5H4.5V118.5H3.5V117.5H2.5V116.5H1.5V115.5H0.5V52.5H1.5V51.5H2.5V50.5H3.5V49.5H4.5V48.5H139.5Z",
    stroke: "#FAFAE8",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 72V71H9V70H8V58H9V57H10V56H22V57H23V58H24V70H23V71H22V72H10Z",
    fill: "#6A685C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 56.5V57.5H22.5V58.5H23.5V69.5H22.5V70.5H21.5V71.5H10.5V70.5H9.5V69.5H8.5V58.5H9.5V57.5H10.5V56.5H21.5Z",
    stroke: "#FAFAE8",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5 56.5V57.5H95.5V58.5H96.5V59.5H97.5V68.5H96.5V69.5H95.5V70.5H94.5V71.5H69.5V70.5H68.5V69.5H67.5V68.5H66.5V59.5H67.5V58.5H68.5V57.5H69.5V56.5H94.5Z",
    fill: "#1E1E22",
    stroke: "#FCFF62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 72H107V71H106V70H105V69H104V59H105V58H106V57H107V56H133V57H134V58H135V59H136V69H135V70H134V71H133V72Z",
    fill: "#6A685C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5 56.5V57.5H133.5V58.5H134.5V59.5H135.5V68.5H134.5V69.5H133.5V70.5H132.5V71.5H107.5V70.5H106.5V69.5H105.5V68.5H104.5V59.5H105.5V58.5H106.5V57.5H107.5V56.5H132.5Z",
    stroke: "#FAFAE8",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 92H10V91H9V90H8V82H9V81H10V80H134V81H135V82H136V90H135V91H134V92Z",
    fill: "#6A685C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.5 80.5V81.5H134.5V82.5H135.5V89.5H134.5V90.5H133.5V91.5H10.5V90.5H9.5V89.5H8.5V82.5H9.5V81.5H10.5V80.5H133.5Z",
    stroke: "#FAFAE8",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 112H10V111H9V110H8V102H9V101H10V100H134V101H135V102H136V110H135V111H134V112Z",
    fill: "#6A685C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.5 100.5V101.5H134.5V102.5H135.5V109.5H134.5V110.5H133.5V111.5H10.5V110.5H9.5V109.5H8.5V102.5H9.5V101.5H10.5V100.5H133.5Z",
    stroke: "#FAFAE8",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 64L82 32",
    stroke: "#FCFF62",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 61L82.0203 65L85 61",
    stroke: "#FCFF62",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5 0V2H91.5V4H93.5V6H95.5V22H93.5V24H91.5V26H89.5V28H73.5V26H71.5V24H69.5V22H67.5V6H69.5V4H71.5V2H73.5V0H89.5Z",
    fill: "#EAEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8452 6.45459V7.90913H77.2997V6.45459H75.8452Z",
    fill: "#EAEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6633 6.45459V7.90913H83.1179V6.45459H81.6633Z",
    fill: "#EAEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4814 6.45459V7.90913H88.936V6.45459H87.4814Z",
    fill: "#EAEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2998 7.90909H78.7544V9.36364H80.2089V7.90909H81.6634V6.45455H83.118V5H80.2089V6.45455H77.2998V7.90909Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1179 7.90909H84.5725V9.36364H86.027V7.90909H87.4816V6.45455H88.9361V5H86.027V6.45455H83.1179V7.90909Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.936 7.90913H90.3906V6.45459H88.936V7.90913Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9361 7.90918V18.091H75.8452V7.90918H74.3906V19.5456H90.3906V7.90918H88.9361Z",
    fill: "#EAEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3905 7.90909V19.5455H74.3905V7.90909H75.8451V6.45455H77.2996V5H74.3905V6.45455H72.936V7.90909H71.4814V21H91.8451V7.90909H90.3905Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8452 9.36372V18.091H88.9361V7.90918H87.4816V9.36372H86.027V10.8183H84.5725V9.36372H83.1179V7.90918H81.6634V9.36372H80.2088V10.8183H78.7543V9.36372H77.2997V7.90918H75.8452V9.36372ZM80.2088 15.9092V12.2728H84.5725V13.7274H81.6634V15.1819H84.5725V16.6365H80.2088V15.9092Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2998 9.36372H78.7544V7.90918H77.2998V9.36372Z",
    fill: "#EAEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6633 9.36372V7.90918H80.2087V9.36372H81.6633Z",
    fill: "#EAEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1179 9.36372H84.5725V7.90918H83.1179V9.36372Z",
    fill: "#EAEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4816 9.36372V7.90918H86.0271V9.36372H87.4816Z",
    fill: "#EAEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7544 10.8178H80.2089V9.36328H78.7544V10.8178Z",
    fill: "#EAEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5725 10.8178H86.0271V9.36328H84.5725V10.8178Z",
    fill: "#EAEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6633 16.6361H84.5724V15.1816H81.6633V13.727H84.5724V12.2725H80.2087V16.6361H81.6633Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3248_5001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketInstructionOne);
export default __webpack_public_path__ + "static/media/MarketInstructionOne.f3305c144c3f667bc029faaebeb2b450.svg";
export { ForwardRef as ReactComponent };